// delivery-option.utils.ts

import type { FindDeliveryOptionQuery } from "@/libs/generated/operations";
import type {
  DeliveryOptionFormValues,
  DeliveryOptionPartnerAssignmentFormValues,
} from "@/schemas/DeliveryForm/delivery-option.schema";

type OriginalDeliveryOptionRecord = FindDeliveryOptionQuery["findDeliveryOption"];

export type DeliveryOptionRecord = OriginalDeliveryOptionRecord;
export type OrgRecord = { slug: string; name: string; logo?: string | null };

export function errMsg(err: unknown): string {
  return err instanceof Error ? err.message : "Something went wrong";
}

export function generateCode(name: string): string {
  const base = name
    .toUpperCase()
    .replace(/[^A-Z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "")
    .slice(0, 16);
  const suffix = Math.random().toString(36).slice(2, 6).toUpperCase();
  return base ? `${base}_${suffix}` : `OPT_${suffix}`;
}

export function toFormValues(r: DeliveryOptionRecord): DeliveryOptionFormValues {
  const fileType = r.fileType === "IMAGE" || r.fileType === "PDF" ? r.fileType : null;

  return {
    name: r.name,
    defaultClientPrice: Number(r.defaultClientPrice),
    visibilityMode: r.visibilityMode,
    requireInput: r.requireInput ?? false,
    requiresFile: r.requiresFile ?? false,
    requiresMultipleFiles: r.requiresMultipleFiles ?? false,
    dynamicPricing: r.dynamicPricing ?? false,
    fileType,
    active: r.active ?? true,
    partnerAssignments: [],
  };
}

export function buildAssignments(
  orgs: OrgRecord[],
  existing?: Array<{
    organizationId: string;
    enabled: boolean;
    displayName?: string | null;
    clientPrice?: number | null;
  }> | null,
  defaultDisplayName: string = ""
): DeliveryOptionPartnerAssignmentFormValues[] {
  const byId = new Map((existing ?? []).map((a) => [a.organizationId, a]));
  return orgs.map((org) => {
    const ex = byId.get(org.slug);
    return {
      organizationId: org.slug,
      selected: ex != null,
      enabled: ex?.enabled ?? false,
      displayName: ex?.displayName ?? defaultDisplayName,
      clientPrice: ex?.clientPrice ?? null,
    };
  });
}
